/**
 * AAA IDP application reducer
 * 
 */
import { APPLICATION_START, DELETE } from '../../actions/types';
export const initialState = {
  club: {
    abbreviation: '',
    id: '',
    name: ''
  },
  created_at: '',
  id: '',
  submission_token: '',
  referrer: ''
};
export default function (state = initialState, action) {
  switch (action.type) {
    case APPLICATION_START:
      return {
        ...state,
        ...action.value
      };
    case DELETE:
      return {
        ...initialState
      };
    default:
      return state;
  }
}